<template>
  <div>
    <FormSection title='Special Rabbi Hauer zt"l Issue of Jewish Action'>
    <div class="hauer__memorial">A special edition of Jewish Action celebrating his enduring legacy, with a focus on his life and a deep dive into his bold vision. (Available to over 100,000 Jewish Action readers, due out Rosh Hashanah time)</div>
      <div class="minyan-section">
        <div class="styled-radio-container styled-radio-container--ou-donation row">
          <div class="amount-row">
            <input
              :id="`1amount${amounts[0][0]}`"
              type="radio"
              class="amount"
              @click="selectedAmount = amounts[0][0];
              selectedAmountDescription = amounts[0][1];
              "
              :checked="(selectedAmount == amounts[0][0] && selectedAmountDescription == amounts[0][1])"
            />
            <FormLabel :for="`1amount${amounts[0][0]}`">
              <MoneyFormat
                class="label-amount"
                :value="amounts[0][0]"
                :currencyCode="form.currency"
                :hide-subunits="true"
              />
              <span class="label-description">{{ amounts[0][1] }}</span>
            </FormLabel>
          </div>
          <div class="amount-row">
            <input
              :id="`2amount${amounts[1][0]}`"
              type="radio"
              class="amount"
              @click="selectedAmount = amounts[1][0]; selectedAmountDescription = amounts[1][1];"
              :checked="(selectedAmount == amounts[1][0] && selectedAmountDescription == amounts[1][1])"
            />
            <FormLabel :for="`2amount${amounts[1][0]}`">
              <MoneyFormat
                class="label-amount"
                :value="amounts[1][0]"
                :currencyCode="form.currency"
                :hide-subunits="true"
              />
              <span class="label-description">{{ amounts[1][1] }}</span>
            </FormLabel>
          </div>
          <div class="amount-row dedicated-ribbon">
            <span class="ribbon">DEDICATED</span>
            <input
              :id="`3amount${amounts[2][0]}`"
              type="radio"
              class="amount"
              @click="selectedAmount = amounts[2][0]; selectedAmountDescription = amounts[2][1];"
              :checked="(selectedAmount == amounts[2][0] && selectedAmountDescription == amounts[2][1])"
              disabled
            />
            <FormLabel :for="`3amount${amounts[2][0]}`">
              <MoneyFormat
                class="label-amount"
                :value="amounts[2][0]"
                :currencyCode="form.currency"
                :hide-subunits="true"
              />
              <span class="label-description">{{ amounts[2][1] }}</span>
            </FormLabel>
          </div>
          <div class="amount-row">
            <input
              :id="`4amount${amounts[3][0]}`"
              type="radio"
              class="amount"
              @click="selectedAmount = amounts[3][0]; selectedAmountDescription = amounts[3][1];"
              :checked="(selectedAmount == amounts[3][0] && selectedAmountDescription == amounts[3][1])"
            />
            <FormLabel :for="`4amount${amounts[3][0]}`">
              <MoneyFormat
                class="label-amount"
                :value="amounts[3][0]"
                :currencyCode="form.currency"
                :hide-subunits="true"
              />
              <span class="label-description">{{ amounts[3][1] }}</span>
            </FormLabel>
          </div>
          <div class="amount-row">
            <input
              :id="`5amount${amounts[4][0]}`"
              type="radio"
              class="amount"
              @click="selectedAmount = amounts[4][0]; selectedAmountDescription = amounts[4][1];"
              :checked="(selectedAmount == amounts[4][0] && selectedAmountDescription == amounts[4][1])"
            />
            <FormLabel :for="`5amount${amounts[4][0]}`">
              <MoneyFormat
                class="label-amount"
                :value="amounts[4][0]"
                :currencyCode="form.currency"
                :hide-subunits="true"
              />
              <span class="label-description">{{ amounts[4][1] }}</span>
            </FormLabel>
          </div>
          <div class="amount-row">
            <input
              :id="`6amount${amounts[5][0]}`"
              type="radio"
              class="amount"
              @click="selectedAmount = amounts[5][0]; selectedAmountDescription = amounts[5][1];"
              :checked="(selectedAmount == amounts[5][0] && selectedAmountDescription == amounts[5][1])"
            />
            <FormLabel :for="`6amount${amounts[5][0]}`">
              <MoneyFormat
                class="label-amount"
                :value="amounts[5][0]"
                :currencyCode="form.currency"
                :hide-subunits="true"
              />
              <span class="label-description">{{ amounts[5][1] }}</span>
            </FormLabel>
          </div>
          <div class="amount-row">
            <input
              :id="`7amount${amounts[6][0]}`"
              type="radio"
              class="amount"
              @click="selectedAmount = amounts[6][0]; selectedAmountDescription = amounts[6][1];"
              :checked="(selectedAmount == amounts[6][0] && selectedAmountDescription == amounts[6][1])"
            />
            <FormLabel :for="`7amount${amounts[6][0]}`">
              <MoneyFormat
                class="label-amount"
                :value="amounts[6][0]"
                :currencyCode="form.currency"
                :hide-subunits="true"
              />
              <span class="label-description">{{ amounts[6][1] }}</span>
            </FormLabel>
          </div>
          <div class="amount-row">
            <input
              :id="`8amount2${amounts[7][0]}`"
              type="radio"
              class="amount"
              @click="selectedAmount = amounts[7][0]; selectedAmountDescription = amounts[7][1];"
              :checked="(selectedAmount == amounts[7][0] && selectedAmountDescription == amounts[7][1])"
            />
            <FormLabel :for="`8amount2${amounts[7][0]}`">
              <MoneyFormat
                class="label-amount"
                :value="amounts[7][0]"
                :currencyCode="form.currency"
                :hide-subunits="true"
              />
              <span class="label-description">{{ amounts[7][1] }}</span>
            </FormLabel>
          </div>

          <div class="amount_other__wrapper amount-row">
            <input
              id="amount_other_ja"
              type="radio"
              class="amount"
              :checked="customSelectedJA"
              @click="customSelectedJA = true"
            />
            <input
              type="number"
              min="1"
              name="amount_other_ja"
              placeholder="Other amount"
              v-model="customAmountJA"
            />
          </div>          
        </div>
      </div>
      
          <div class="custom__messaging" v-if="show180Message">
            <FormRow>
              <FormLabel class="control-label">
                140-character message
              </FormLabel>
            </FormRow>
            <FormRow>
              <FormInput type="textarea" class="width-full" field="custom.Notes" :maxlength="140" />
            </FormRow>
          </div> 
    </FormSection>
    <FormSection title='Book of Inspiring, Historical Biographies by Rabbi Hauer zt"l'>
      <div class="hauer__memorial">A volume of Rabbi Hauer's inspirational historical biographies, adapted from his celebrated Tisha B'Av kinos lectures. (Available in bookstores and online)</div>    
      <div class="minyan-section">
        <div class="styled-radio-container styled-radio-container--ou-donation row">

       <div class="amount-row dedicated-ribbon">
            <span class="ribbon">DEDICATED</span>
            <input
              :id="`amount3${amounts[8][0]}`"
              type="radio"
              class="amount"
              @click="selectedAllocationAmount = amounts[8][0]; selectedAllocationDescription = amounts[8][1];"
              :checked="(selectedAllocationAmount == amounts[8][0] && selectedAllocationDescription == amounts[8][1])"
              disabled
            />
            <FormLabel :for="`amount3${amounts[8][0]}`">
              <MoneyFormat
                class="label-amount"
                :value="amounts[8][0]"
                :currencyCode="form.currency"
                :hide-subunits="true"
              />
              <span class="label-description">{{ amounts[8][1] }}</span>
            </FormLabel>
          </div>
          <div class="amount-row">
            <input
              :id="`amount4${amounts[9][0]}`"
              type="radio"
              class="amount"
              @click="selectedAllocationAmount = amounts[9][0]; selectedAllocationDescription = amounts[9][1];"
              :checked="(selectedAllocationAmount == amounts[9][0] && selectedAllocationDescription == amounts[9][1])"
            />
            <FormLabel :for="`amount4${amounts[9][0]}`">
              <MoneyFormat
                class="label-amount"
                :value="amounts[9][0]"
                :currencyCode="form.currency"
                :hide-subunits="true"
              />
              <span class="label-description">{{ amounts[9][1] }}</span>
            </FormLabel>
          </div>
          <div class="amount-row">
            <input
              :id="`amount5${amounts[10][0]}`"
              type="radio"
              class="amount"
              @click="selectedAllocationAmount = amounts[10][0]; selectedAllocationDescription = amounts[10][1];"
              :checked="(selectedAllocationAmount == amounts[10][0] && selectedAllocationDescription == amounts[10][1])"
            />
            <FormLabel :for="`amount5${amounts[10][0]}`">
              <MoneyFormat
                class="label-amount"
                :value="amounts[10][0]"
                :currencyCode="form.currency"
                :hide-subunits="true"
              />
              <span class="label-description">{{ amounts[10][1] }}</span>
            </FormLabel>
          </div>
          <div class="amount-row">
            <input
              :id="`amount5${amounts[11][0]}`"
              type="radio"
              class="amount"
              @click="selectedAllocationAmount = amounts[11][0]; selectedAllocationDescription = amounts[11][1];"
              :checked="(selectedAllocationAmount == amounts[11][0] && selectedAllocationDescription == amounts[11][1])"
            />
            <FormLabel :for="`amount5${amounts[11][0]}`">
              <MoneyFormat
                class="label-amount"
                :value="amounts[11][0]"
                :currencyCode="form.currency"
                :hide-subunits="true"
              />
              <span class="label-description">{{ amounts[11][1] }}</span>
            </FormLabel>
          </div>
          <div class="amount_other__wrapper amount-row">
            <input
              id="amount_other_book"
              type="radio"
              class="amount"
              :checked="customSelectedBook"
              @click="customSelectedBook = true"
            />
            <input
              type="number"
              min="1"
              name="amount_other_book"
              placeholder="Other amount"
              v-model="customAmountBook"
            />
          </div>
         
        </div>
      </div>
    </FormSection>
  </div>
</template>
<script lang="ts">
import { computed, defineComponent, type PropType, ref, watch } from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";

import type { Currency } from "~/form-settings";
import { queryParams } from "~/shared/query-params";

export default defineComponent({
  data() {
    return {
      view: "welcome",
    };
  },
  props: {
    campaign: String,
    nocustom: Boolean,
  },
  emits: ['update:selectedDescription', 'update:selectedAmount'],
  setup(props, { emit }) {
    const { setValue, form, submit, settings } = usePaymentForm();

    if (props.campaign) {
      setValue("applications.0.campaign", props.campaign);
    }

    const selectedAmount = ref();
    const selectedAllocationAmount = ref();
    const selectedAmountDescription = ref();
    const selectedAllocationDescription = ref();
    const customAmountJA = ref();
    const customAmountBook = ref();
    const customSelectedJA = ref(false);
    const customSelectedBook = ref(false);

    watch(selectedAmountDescription, (desc) => {
      emit('update:selectedDescription', desc);
      if (desc) {
        setValue('custom.SpecialEdition', desc);
      }
    });

    watch(selectedAllocationDescription, (desc) => {
      if (desc) {
        setValue('custom.Book', desc);
      }
    });

    watch(selectedAmount, (selectedAmount) => {
      if (selectedAmount) {
        customSelectedJA.value = false;
        customSelectedBook.value = false;
        customAmountJA.value = null;
        customAmountBook.value = null;
        
        emit('update:selectedAmount', selectedAmount);

        if (selectedAllocationAmount.value) {
          const totalAmount = parseInt(selectedAmount) + selectedAllocationAmount.value;
          setValue("amount", "" + totalAmount);
          
          // Clear and rebuild applications array
          setValue("applications", []);
          const apps = [];
          
          if (selectedAmount > 0) {
            apps.push({
              amount: selectedAmount,
              department: "JewishMediaAndPublications",
              campaign: "Jewish Action Donation",
              subCampaign: "Jewish Action R. Hauer Memorial Edition"
            });
          }
          
          if (selectedAllocationAmount.value > 0) {
            apps.push({
              amount: selectedAllocationAmount.value,
              department: "JewishMediaAndPublications",
              campaign: "Rabbi Hauer Book of Biographies",
              subCampaign: null
            });
          }
          
          apps.forEach((app, index) => {
            setValue(`applications.${index}.amount`, app.amount);
            setValue(`applications.${index}.department`, app.department);
            setValue(`applications.${index}.campaign`, app.campaign);
            setValue(`applications.${index}.subCampaign`, app.subCampaign);
          });
        } else {
          setValue("amount", "" + selectedAmount);
          // Clear applications since this is from Jewish Action section only (default campaign)
          setValue("applications", []);
        }
      }
    });

    watch(selectedAllocationAmount, (selectedAllocationAmount) => {
      if (selectedAllocationAmount) {
        customSelectedJA.value = false;
        customSelectedBook.value = false;
        customAmountJA.value = null;
        customAmountBook.value = null;

        if (selectedAmount.value) {
          const totalAmount = parseInt(selectedAllocationAmount) + selectedAmount.value;
          setValue("amount", "" + totalAmount);
          
          // Clear and rebuild applications array
          setValue("applications", []);
          const apps = [];
          
          if (selectedAmount.value > 0) {
            apps.push({
              amount: selectedAmount.value,
              department: "JewishMediaAndPublications",
              campaign: "Jewish Action Donation",
              subCampaign: "Jewish Action R. Hauer Memorial Edition"
            });
          }
          
          if (selectedAllocationAmount > 0) {
            apps.push({
              amount: selectedAllocationAmount,
              department: "JewishMediaAndPublications",
              campaign: "Rabbi Hauer Book of Biographies",
              subCampaign: null
            });
          }
          
          apps.forEach((app, index) => {
            setValue(`applications.${index}.amount`, app.amount);
            setValue(`applications.${index}.department`, app.department);
            setValue(`applications.${index}.campaign`, app.campaign);
            setValue(`applications.${index}.subCampaign`, app.subCampaign);
          });
        } else {
          setValue("amount", "" + selectedAllocationAmount);
          
          // Set up application for Book campaign only
          setValue("applications.0.amount", selectedAllocationAmount);
          setValue("applications.0.department", "JewishMediaAndPublications");
          setValue("applications.0.campaign", "Rabbi Hauer Book of Biographies");
          setValue("applications.0.subCampaign", null);
        }
      }
    });

    watch(customSelectedJA, (customSelectedJA) => {
      if (customSelectedJA) {
        selectedAmount.value = null;
        selectedAmountDescription.value = null;
        customSelectedBook.value = false;
      }
    });

    watch(customSelectedBook, (customSelectedBook) => {
      if (customSelectedBook) {
        selectedAllocationAmount.value = null;
        selectedAllocationDescription.value = null;
        customSelectedJA.value = false;
      }
    });

    watch(customAmountJA, async (customAmountJA) => {
      if (customAmountJA) {
        selectedAmount.value = null;
        selectedAmountDescription.value = null;
        customSelectedJA.value = true;
      }

      await Vue.nextTick();

      if (customAmountJA && selectedAmount.value === null) {
        if (selectedAllocationAmount.value || customAmountBook.value) {
          const bookAmount = selectedAllocationAmount.value || customAmountBook.value;
          const totalAmount = parseInt(customAmountJA) + parseInt(bookAmount);
          setValue("amount", "" + totalAmount);
          
          // Clear and rebuild applications array
          setValue("applications", []);
          const apps = [];
          
          if (parseInt(customAmountJA) > 0) {
            apps.push({
              amount: customAmountJA,
              department: "JewishMediaAndPublications",
              campaign: "Jewish Action Donation",
              subCampaign: "Jewish Action R. Hauer Memorial Edition"
            });
          }
          
          if (parseInt(bookAmount) > 0) {
            apps.push({
              amount: bookAmount,
              department: "JewishMediaAndPublications",
              campaign: "Rabbi Hauer Book of Biographies",
              subCampaign: null
            });
          }
          
          apps.forEach((app, index) => {
            setValue(`applications.${index}.amount`, app.amount);
            setValue(`applications.${index}.department`, app.department);
            setValue(`applications.${index}.campaign`, app.campaign);
            setValue(`applications.${index}.subCampaign`, app.subCampaign);
          });
        } else {
          setValue("amount", customAmountJA || null);
          setValue("applications", []);
        }
      }
    });

    watch(customAmountBook, async (customAmountBook) => {
      if (customAmountBook) {
        selectedAllocationAmount.value = null;
        selectedAllocationDescription.value = null;
        customSelectedBook.value = true;
      }

      await Vue.nextTick();

      if (customAmountBook && selectedAllocationAmount.value === null) {
        if (selectedAmount.value || customAmountJA.value) {
          const jaAmount = selectedAmount.value || customAmountJA.value;
          const totalAmount = parseInt(customAmountBook) + parseInt(jaAmount);
          setValue("amount", "" + totalAmount);
          
          // Clear and rebuild applications array
          setValue("applications", []);
          const apps = [];
          
          if (parseInt(jaAmount) > 0) {
            apps.push({
              amount: jaAmount,
              department: "JewishMediaAndPublications",
              campaign: "Jewish Action Donation",
              subCampaign: "Jewish Action R. Hauer Memorial Edition"
            });
          }
          
          if (parseInt(customAmountBook) > 0) {
            apps.push({
              amount: customAmountBook,
              department: "JewishMediaAndPublications",
              campaign: "Rabbi Hauer Book of Biographies",
              subCampaign: null
            });
          }
          
          apps.forEach((app, index) => {
            setValue(`applications.${index}.amount`, app.amount);
            setValue(`applications.${index}.department`, app.department);
            setValue(`applications.${index}.campaign`, app.campaign);
            setValue(`applications.${index}.subCampaign`, app.subCampaign);
          });
        } else {
          setValue("amount", customAmountBook || null);
          
          setValue("applications.0.amount", customAmountBook);
          setValue("applications.0.department", "JewishMediaAndPublications");
          setValue("applications.0.campaign", "Rabbi Hauer Book of Biographies");
          setValue("applications.0.subCampaign", null);
        }
      }
    });

    function clearOutSelectedValue() {
      selectedAmount.value = null;
      selectedAllocationAmount.value = null;
      setValue("amount", null);
    }

    const amounts = computed(() => {
      const amounts = settings!.amounts! as
        | [number, string][]
        | [Partial<{ [key in Currency]: number }>, string][];

      if (typeof amounts[0][0] == "number") return amounts;

      return (amounts as [
        Partial<{ [key in Currency]: number }>,
        string
      ][]).map(([amounts, label]) => [amounts[form.value.currency!], label]);
    });

    const show180Message = computed(() => {
      return selectedAmount.value === 180 && selectedAmountDescription.value === 'Dedication with 140-character message';
    });

    return {
      form,
      amounts,
      selectedAmount,
      selectedAllocationAmount,
      selectedAmountDescription,
      selectedAllocationDescription,
      customAmountJA,
      customAmountBook,
      customSelectedJA,
      customSelectedBook,
      clearOutSelectedValue,
      show180Message,
    };
  },
});
</script>
<style scoped lang="scss">
.selector {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  label {
    font-weight: 400;
    font-size: 20px;
    color: black;
  }
  select {
    max-width: 300px;
    margin-left: 20px;
  }
}
.styled-radio-container--ou-donation.styled-radio-container {
    justify-content: flex-start;
    gap: 2%;
  margin: 0 0 5px 0px;
  display: flex;
  flex-wrap: wrap;
  width: 100%;

  input[type="radio"] {
    height: 0;
    top: 20px;
    position: absolute;
    left: 20px;
    z-index: -1;
    visibility: hidden;
  }
  label {
    background: #fff;
    border: 1px solid #ddd;
    font-weight: bold;
    color: rgb(87, 87, 87);
    width: 100%;
    border-radius: 4px;
    cursor: pointer;
    display: block;
    height: 100%;
    display: flex;
    overflow: hidden;
  }

  input[type="radio"]:disabled + label {
    opacity: 0.5;
    cursor: not-allowed;
    pointer-events: none;
  }
  label:hover {
    background: #e9f0f7;
  }
  .amount_other__wrapper {
    position: relative;
    min-width: 22%;
    overflow: hidden;
    border: 1px solid #ddd;
    border-radius: 4px;
    padding-left: 5px;
    flex: 1;
    line-height: 1;
    @media (max-width: 720px) {
      margin-right: 5px;
      margin-left: 5px;
      margin-bottom: 10px;
    }
    &:before {
      content: "$";
      position: absolute;
      padding: 15px 8px;
      border-right: 1px solid #ddd;
      height: 100%;
      background: #f7f7f7;
      text-align: center;
      top: 0px;
      left: 0;
      width: 70px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    input[type="number"] {
      border: none;
      background: #fff;
      margin-left: 70px;
      box-shadow: none;
      max-width: 85%;
    }
  }
}
.amount-row {
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  width: 100%;
  position: relative;
  @media (min-width: 720px) {
    min-width: 49%;
    max-width: 49%;
  }
}
.amount-row.dedicated-ribbon {
  overflow: hidden;
  .ribbon {
    position: absolute;
    top: 20px;
    right: -23px;
    background: #d4af37;
    color: white;
    width: 103px;
    font-weight: bold;
    font-size: 10px;
    padding: 4px;
    transform: rotate(45deg);
    z-index: 10;
    text-align: center;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
    letter-spacing: 0.5px;
  }
}
.amount {
  margin-right: 7px;
}
.label-amount {
  font-weight: bold;
  display: inline-block;
  padding: 10px;
  align-items: center;
  min-width: 70px;
  max-width: 70px;
  justify-content: center;
  background: #f7f7f7;
  height: 100%;
  display: flex;
  border-right: 1px solid #efefef;
}
.amount-row:hover {
  .label-amount {
    border-right: 1px solid #ddd;
    background: #efefef;
  }
}
#amount_other {
  max-width: 200px;
}
.label-description {
  font-weight: normal;
  padding: 10px;
  align-items: center;
  justify-content: center;
  height: 100%;
  display: flex;
  font-size: 12px;
  line-height: 1.4;
}
.minyan-section {
  padding: 0.5rem 0 0;
}
.hauer__memorial {
    color: #585e6a;
    font-size: 16px;
    line-height: 1.3;
    padding-bottom: 10px;
}

::v-deep .custom__messaging{
  margin-top: 10px;

  textarea {
    font-family: inherit;
    padding-top: 9px;
}
}


::v-deep .styled-radio-container.styled-radio-container--ou-donation.row{
  .amount-row{
        @media only screen and (min-width: 720px) {
            min-width: 32%;
          max-width: 32%;
        }

        label{
    display: flex !important;
    flex-flow: column-reverse !important;
    justify-content: space-between;
    border-radius: 6px;
    align-items: center;
        background: #e5e8e9;
            padding: 10px;
    color: #222;
    gap: 0px;
    &:hover{
      background: #cdd5d7;
    color: black;
    }
        }
.label-description{
    padding: 0px;
    color: #222;
    font-weight: 600;
    font-size: 13px;
    text-align: center;
}
        .label-amount{
    max-width: none;
    min-width: auto;
    background: inherit;
    padding: 8px 0px 0px;
    border: none;
    font-size: 16px;
    margin-top: 3px;
    position: relative;
    &:before{
position: absolute;
    top: 0px;
    content: "";
    max-width: 34px;
    height: 1px;
    left: 0px;
    background: #8b8686;
    right: 0px;
    margin: auto;
    }
        }

        input[type=radio]:checked + label {
    background: #133271;
    color: #fff;
    .label-description{
      color: #fff;
    }
}
  }
}
</style>
